import m from 'mithril'

import { map, Mapbox, Source, Layer } from '@shared/components/mapbox'

import Navbar from '@app/components/layout-navbar'

// import { zoom } from '@shared/utils/map'





const Loading = {}

Loading.view = vnode => {
    
    return m('div.page', [
        // m(PageLoader, {loading_page: vnode.state.loading_page}),
        m(Navbar),
        m('div.page__map_container', [
            m(Mapbox),
        ]),
    ])
}


export default Loading